var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-layout",
    [
      _vm.isMobile
        ? _c(
            "drawer",
            {
              attrs: { openDrawer: _vm.collapsed },
              on: { change: _vm.onDrawerChange }
            },
            [
              _c("sider-menu", {
                attrs: {
                  theme: _vm.theme,
                  menuData: _vm.systemAuths,
                  collapsed: false,
                  collapsible: false
                },
                on: { menuSelect: _vm.onMenuSelect }
              })
            ],
            1
          )
        : _vm.layout === "side"
        ? _c("sider-menu", {
            staticClass: "sidebar-container",
            attrs: {
              theme: _vm.theme,
              menuData: _vm.systemAuths,
              collapsed: _vm.collapsed,
              collapsible: true
            },
            on: { systemMenuClick: _vm.systemMenuClick }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-layout",
        [
          _vm.isMobile
            ? _c("global-header", {
                attrs: { menuData: _vm.systemAuths, collapsed: _vm.collapsed },
                on: { toggleCollapse: _vm.toggleCollapse }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile
            ? _c("global-header", {
                class: _vm.collapsed == true ? "left80" : "left256",
                attrs: { menuData: _vm.systemAuths, collapsed: _vm.collapsed },
                on: { toggleCollapse: _vm.toggleCollapse }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isMobile
            ? _c(
                "a-layout-content",
                {
                  staticStyle: {
                    "margin-top": "24px",
                    "margin-left": "24px",
                    "margin-right": "24px"
                  }
                },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile && _vm.collapsed
            ? _c(
                "a-layout-content",
                {
                  style: {
                    minHeight: _vm.minHeight,
                    margin: "20px 20px 0 104px"
                  }
                },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile && !_vm.collapsed
            ? _c(
                "a-layout-content",
                {
                  style: {
                    minHeight: _vm.minHeight,
                    margin: "20px 20px 0 280px"
                  }
                },
                [_vm._t("default")],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isMobile
            ? _c(
                "a-layout-footer",
                { staticStyle: { "margin-top": "5px" } },
                [
                  _c("global-footer", {
                    staticStyle: { "margin-left": "256px" },
                    attrs: {
                      "link-list": _vm.linkList,
                      copyright: _vm.copyright
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isMobile
            ? _c(
                "a-layout-footer",
                { staticStyle: { "margin-top": "5px" } },
                [
                  _c("global-footer", {
                    attrs: {
                      "link-list": _vm.linkList,
                      copyright: _vm.copyright
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6cf2f728", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf2f728","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/GlobalLayout.vue
// module id = null
// module chunks = 